import React, { Component } from 'react';
import injectsheet from 'react-jss';
import Slider from 'react-slick';
import StudentsList from '../../data/student.json';


const styles = {
    achievements: {
        position: 'relative',
        paddingTop: '25px',
        textAlign: 'center',
        '@media screen and (max-width: 767px)':{
            marginLeft: '3%',
            marginRight: '2%',
        },
        '& .title':{
            width: '100%',
            marginTop: '2%',
            marginBottom:'3%',
            '& h2':{
                color: '#ea9044',
                borderBottom: '2px solid #91230c',
                position: 'relative',
                display: 'inline-block',
                '@media screen and (max-width: 767px)':{
                    fontSize: '1.6rem',
                    marginBottom: '5%',
                },

            }
        },
        '& .student':{
            '& .student-body':{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                '& .student-img':{
                    height: '150px',
                    width: '150px',
                    '@media (max-width: 1199px)': {
                        height: '120px',
                        width: '120px',
                    },
                    '@media (max-width: 767px)': {
                        height: '100px',
                        width: '100px',
                    },
                    '@media (max-width: 385px)': {
                        height: '80px',
                        width: '80px',
                    },
                },
                '& .frame': {
                    position: 'absolute',
                    width: '176px',
                    top: 0,
                    '@media (max-width: 1199px)': {
                        width: '140px',
                    },
                    '@media (max-width: 767px)': {
                        width: '120px',
                    },
                    '@media (max-width: 385px)': {
                        width: '94px',
                    },
                    '& img':{
                        width: '100%',
                    },
                    '& .rank': {
                        position: 'absolute',
                        bottom: '8%',
                        fontSize: '1.8rem',
                        left: '-12px',
                        color: '#2450ff',
                        textShadow:'0 0 5px #5b71c7',
                        fontWeight: '400',
                        lineHeight: '1',
                        '& strong': {
                            fontWeight: '700',
                        },
                        '@media (max-width: 1199px)': {
                            fontSize: '1.3rem'
                        },
                        '@media (max-width: 767px)': {
                            fontSize: '1rem',
                            left: 0
                        },
                        '@media (max-width: 385px)': {
                            bottom: '2px'
                        },
                    }
                }
            },
            '& .student-qualification':{
                '& .exam':{
                    color: '#2450ff',
                    fontWeight: '700',
                    '@media (max-width: 767px)': {
                        fontSize: '.8rem',
                    },
                    '@media (max-width: 385px)': {
                        fontSize: '.6rem',
                    },
                },
                '& .student-name':{
                    '@media (max-width: 767px)': {
                        fontSize: '1rem',
                    },
                    '@media (max-width: 385px)': {
                        fontSize: '.8rem',
                    },
                }
            },
        },
    }
}

class Achievements extends Component {

  render() {
      const {classes} = this.props;
      const settings = {
          dots: true,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 4000,
          speed: 1000,
          slidesToShow: 5,
          slidesToScroll: 4,
          responsive: [
              {
                  breakpoint: 992,
                  settings: {
                      slidesToShow: 4,
                      slidesToScroll: 3,
                      dots: false
                  }
              },
              {
                  breakpoint: 505,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                      dots: false
                  }
              },
          ]
      };


      const students = StudentsList.slice(0, 30).map((student, index) =>
              <div key={index} className="student p-3">
                  <div className="student-body">
                      <div className="frame">
                          <img src="../images/frame.svg" alt="" className=""/>
                          {(student.rank) ? <h2 className="rank">AIR<br/><strong>{student.rank}</strong></h2> : null}
                      </div>
                      <img className="student-img rounded-circle" src={student.img} alt={student.name}/>
                  </div>
                  <div className="student-qualification w-full text-center pt-3">
                      <h6 className="exam">{student.exam}</h6>
                      <h5 className="student-name align-self-center lead text-uppercase">{student.name}</h5>
                  </div>
              </div>
      );

      return (
      <div className={classes.achievements}>
          <div className="title">
              <h2>Achievements of Our Students</h2>
          </div>
          <div className="container">
              <Slider {...settings}>
                  {students}
              </Slider>
              {/*<div className="row flex-wrap">*/}
                  {/*{students}*/}
              {/*</div>*/}
          </div>
      </div>
    );
  }
}

export default injectsheet(styles)(Achievements);